import "./Footer.css";
import React, { useState } from "react";

const Footer = () => {
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);

  const toggleImpressum = () => {
    setShowImpressum(!showImpressum);
  };
  const toggleDatenschutz = () => {
    setShowDatenschutz(!showDatenschutz);
  };

  return (
    <footer className="footer">
      <div className="footer-opening-hours">
        <p>
          <strong>Öffnungszeiten:</strong>
        </p>
        <p>Mo: Ruhetag</p>
        <p>Di – Do: 17:00 – 22:30 Uhr</p>
        <p>Fr – Sa: 17:00 – 23:30 Uhr</p>
        <p>So: 13:00 – 22:00 Uhr</p>
      </div>
      <br />
      <br />


      <div footer-link>
        {" "}
        <h4 style={{ cursor: "pointer" }} onClick={toggleImpressum}>
          {showImpressum ? "Impressum ausblenden" : "Impressum anzeigen"}
        </h4>
        <h4 style={{ cursor: "pointer" }} onClick={toggleDatenschutz}>
          {showDatenschutz
            ? "Datenschutzerklärung ausblenden"
            : "Datenschutzerklärung anzeigen"}
        </h4>
      </div>

      {showImpressum && (
        <>
          <h2>Angaben gemäß § 5 DDG</h2>
          <p>480Grad neapolitan Pizza X Pianobar</p>
          <p>Foodspace Restaurant & Bar GmbH</p>
          <p>Adresse: Karl-Grillenberger-Straße 28, 90402 Nürnberg</p>
          <p>Telefon: 0176 70349355</p>

          <p>
            <strong>Vertreten durch:</strong>
            <br />- Sarkici
          </p>
        </>
      )}

      {showDatenschutz && (
        <>
          <h2>
            Was wir mit deinen Daten machen, erfährst du hier – kurz &
            verständlich erklärt!
          </h2>

          <h3>1. Allgemeine Hinweise</h3>
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen.
            Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der
            gesetzlichen Bestimmungen (DSGVO, TMG). In dieser
            Datenschutzerklärung informieren wir Sie über die wichtigsten
            Aspekte der Datenverarbeitung auf unserer Website.
          </p>

          <h3>2. Verantwortlicher</h3>
          <p>
            Betreiber der Website:
            <br />
            480Grad neapolitan Pizza X Pianobar
            <br />
            - Sarkici
            <br />
            Karl-Grillenberger-Straße 28
            <br />
            90402 Nürnberg
            <br />
            Telefon: 0176 70349355
            <br />
            E-Mail: 480gradpizza@gmail.com
            <br />
          </p>

          <h3>3. Hosting</h3>
          <p>
            Unsere Website wird bei Netlify (Netlify, Inc., 44 Montgomery
            Street, Suite 300, San Francisco, California 94104, USA) gehostet.
            Beim Besuch unserer Seite erfasst Netlify automatisch sogenannte
            Logfiles, darunter:
          </p>
          <ul>
            <li>IP-Adresse</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Browsertyp und -version</li>
            <li>Betriebssystem</li>
            <li>Referrer-URL</li>
          </ul>
          <p>
            Die Datenverarbeitung erfolgt zur Bereitstellung und Sicherheit der
            Website. Weitere Informationen:
            <a
              href="https://www.netlify.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.netlify.com/privacy/
            </a>
          </p>

          <h3>4. Links zu externen Diensten</h3>
          <h4>a) Instagram</h4>
          <p>
            Unsere Website enthält einen Link zu unserer Instagram-Seite (Meta
            Platforms Ireland Limited). Wenn Sie diesen Link anklicken, gelten
            die Datenschutzrichtlinien von Instagram/Meta. Es können
            personenbezogene Daten (z.B. IP-Adresse, Gerätedaten) an Meta
            übertragen werden.
            <br />
            Mehr dazu:
            <a
              href="https://privacycenter.instagram.com/policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://privacycenter.instagram.com/policy
            </a>
          </p>

          <h4>b) Google Maps</h4>
          <p>
            Wenn Sie auf das Google Maps-Bild oder den Link klicken, wird eine
            Verbindung zu den Servern von Google hergestellt. Dabei können
            Cookies gesetzt und personenbezogene Daten verarbeitet werden (z.B.
            IP-Adresse).
            <br />
            Mehr zur Datenverarbeitung durch Google:
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/privacy
            </a>
          </p>

          <h3>5. Cookies</h3>
          <p>
            Unsere Website selbst verwendet keine Cookies aktiv, allerdings
            können durch das Aufrufen externer Dienste (z. B. Google Maps)
            Cookies gesetzt werden. Beim Klick auf den Google Maps-Link erfolgt
            ein entsprechender Hinweis.
          </p>

          <h3>6. Online-Reservierung über Resmio</h3>
          <p>
            Wir verwenden ein Reservierungs-Widget des Dienstleisters resmio
            GmbH, Katzwanger Straße 150, 90461 Nürnberg, Deutschland, um Ihnen
            eine einfache Möglichkeit zur Tischreservierung zu bieten. Beim
            Aufruf des Widgets werden Daten an die Server von Resmio
            übermittelt. Wenn Sie eine Reservierung vornehmen, werden folgende
            personenbezogene Daten verarbeitet:
          </p>
          <ul>
            <li>Name</li>
            <li>Kontaktdaten (z.B. Telefonnummer oder E-Mail-Adresse)</li>
            <li>Datum und Uhrzeit der Reservierung</li>
            <li>ggf. besondere Wünsche</li>
          </ul>
          <p>
            Die Datenverarbeitung erfolgt ausschließlich zur Bearbeitung Ihrer
            Reservierung.
            <br />
            Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertrag oder
            vorvertragliche Maßnahme)
            <br />
            Weitere Informationen zur Datenverarbeitung durch Resmio:
            <a
              href="https://www.resmio.com/datenschutzerklaerung/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.resmio.com/datenschutzerklaerung/
            </a>
          </p>

          <h3>7. Ihre Rechte</h3>
          <p>Sie haben das Recht auf:</p>
          <ul>
            <li>Auskunft über Ihre gespeicherten Daten</li>
            <li>Berichtigung, Löschung oder Einschränkung der Verarbeitung</li>
            <li>Datenübertragbarkeit</li>
            <li>Widerruf einer erteilten Einwilligung</li>
            <li>Beschwerde bei einer Datenschutzbehörde</li>
          </ul>

          <h3>8. Kontakt für Datenschutzanfragen</h3>
          <p>
            Für datenschutzrechtliche Fragen wenden Sie sich bitte an:
            <br />
            Telefon: 0174/1969108
            <br />
            E-Mail: oni96lgc@gmail.com
          </p>
        </>
      )}
    </footer>
  );
};

export default Footer;
